import React from "react";
import { connectInfiniteHits } from "react-instantsearch-dom";

import Device from "../Device/Device";
import { t } from "i18next";


class InfiniteHits extends React.PureComponent<any> {
  sentinel: HTMLDivElement | null = null;
  intersectionObserver: IntersectionObserver | null = null;
  static defaultProps = {
    renderSearchBox() {
      return null;
    },
  };

  constructor(props: any) {
    super(props);
    this.sentinel = null;
    this.onSentinelIntersection = this.onSentinelIntersection.bind(this);
  }

  // componentDidMount() {
  //   this.intersectionObserver = new IntersectionObserver(
  //     this.onSentinelIntersection
  //   );

  //   this.intersectionObserver.observe(this.sentinel);
  // }
  componentDidMount() {
    if (this.sentinel) {
      this.intersectionObserver = new IntersectionObserver(
        this.onSentinelIntersection
      );
      this.intersectionObserver.observe(this.sentinel); // safe now
    }
  }

  componentWillUnmount() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }
  }

  onSentinelIntersection(entries: any) {
    const { hasMore, refineNext } = this.props;

    entries.forEach((entry: any) => {
      if (entry.isIntersecting && hasMore) {
        refineNext();
      }
    });
  }

  render() {
    const { hits, currentTime  } = this.props;
    
    return (
      <React.Fragment>
        <>
          {hits.map((hit: any) => (
            <React.Fragment key={hit.id}>
              <Device
                data={{
                  ...hit,
                  promotionTextEn: hit?.promotionTextEn?.includes("SAR")
                    ? hit.promotionTextEn.replace(/SAR/g, t("SAR"))
                    : hit?.promotionTextEn,

                  promotionTextAr: hit?.promotionTextAr?.includes("SAR")
                    ? hit.promotionTextAr.replace(/SAR/g, t("SAR"))
                    : hit?.promotionTextAr,
                }}
                currentTime={currentTime}
              />
            </React.Fragment>
          ))}
        </>
        <div
          ref={(c) => {
            this.sentinel = c;
          }}
        />
      </React.Fragment>
    );
  }
}
const CustomInfiniteHits = connectInfiniteHits(InfiniteHits);
export default CustomInfiniteHits;
